<sh-ag-grid-responsive-wrapper [gridApi]="gridApi" class="ag-theme-balham-dark ag-font-din">
	<ag-grid-angular
		[gridOptions]="gridOptions"
		[columnDefs]="columnDefs"
		[rowData]="gridData"
		[getRowId]="getRowId"
		[context]="context"
		(gridReady)="onGridReady($event)"
		(selectionChanged)="onSelectionChanged($event)"
	>
	</ag-grid-angular>
</sh-ag-grid-responsive-wrapper>
